import React, { PureComponent } from "react";
import { NavLink } from "react-router-dom";
import { Menu, Button, Dropdown, Input, Icon } from "@ss/mtd-react3";
import "./BrandSearch.style.scss";

export default class BrandAggregation extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            keyword: props.defaultValue || "",
            isDropdownVisible: false,
            searchHistory: []
        };
        this.searchRef = React.createRef();
    }

    componentDidMount() {
        const { historyKey = "brandAggregationHistory" } = this.props;

        // 从 localStorage 加载搜索历史
        const history = localStorage.getItem(historyKey);
        if (history) {
            this.setState({ searchHistory: JSON.parse(history) });
        }

        // 添加点击外部关闭下拉框的事件监听
        document.addEventListener("click", this.handleClickOutside);
        // 添加窗口大小变化事件监听
        window.addEventListener("resize", this.handleDropdownPosition);
    }
    // 添加 componentDidUpdate 来处理 props 更新
    componentDidUpdate(prevProps) {
        // 当 defaultValue 发生变化时更新 keyword
        if (prevProps.defaultValue !== this.props.defaultValue) {
            this.setState({
                keyword: this.props.defaultValue || ""
            });
        }
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
        window.removeEventListener("resize", this.handleDropdownPosition);
    }
    // 修改 handleDropdownPosition 方法
    handleDropdownPosition = () => {
        if (this.state.isDropdownVisible) {
            this.setDropdownPosition();
        }
    };
    // 添加新方法来设置下拉框位置
    setDropdownPosition = () => {
        if (this.searchRef.current) {
            const dropdown = document.querySelector(".brand-search-dropdown");
            if (dropdown) {
                const searchRect = this.searchRef.current.getBoundingClientRect();
                const viewportHeight = window.innerHeight;
                const footerHeight = 150; // 估计的footer高度

                // 无论位置如何，都设置为绝对定位
                dropdown.style.position = "absolute";
                dropdown.style.top = "100%"; // 定位在搜索框下方
                dropdown.style.left = "0";
                dropdown.style.width = "100%";
                dropdown.style.zIndex = "1000";

                // 检查是否会被footer遮挡
                if (searchRect.bottom + 300 > viewportHeight - footerHeight) {
                    // 如果会被遮挡，改为固定定位
                    dropdown.style.position = "fixed";
                    dropdown.style.top = `${searchRect.bottom}px`;
                    dropdown.style.left = `${searchRect.left}px`;
                    dropdown.style.width = `${searchRect.width}px`;

                    // 计算可见高度
                    const maxVisibleHeight =
                        viewportHeight - searchRect.bottom - 20;
                    dropdown.style.maxHeight = `${Math.min(
                        300,
                        maxVisibleHeight
                    )}px`;
                } else {
                    // 如果不会被遮挡，使用默认最大高度
                    dropdown.style.maxHeight = "300px";
                }
            }
        }
    };
    handleClickOutside = event => {
        if (
            this.searchRef.current &&
            !this.searchRef.current.contains(event.target)
        ) {
            this.setState({ isDropdownVisible: false });
        }
    };

    handleSearch = value => {
        if (!value.trim()) return;
        const { historyKey = "brandAggregationHistory" } = this.props;

        // 更新搜索历史
        const newHistory = [
            value,
            ...this.state.searchHistory.filter(item => item !== value)
        ].slice(0, 6);
        this.setState({ searchHistory: newHistory, isDropdownVisible: false });
        localStorage.setItem(historyKey, JSON.stringify(newHistory));
        // 执行搜索
        // this.props.history.push(`/search?keyword=${encodeURIComponent(value)}`);
        this.setState({ isDropdownVisible: false });
        const encodedValue = encodeURIComponent(value);

        this.props.onSearch?.(encodedValue);
    };

    handleKeyPress = e => {
        if (e.key === "Enter") {
            this.handleSearch(this.state.keyword);
            // this.props.onSearch?.(this.state.keyword);
        }
    };

    handleInputFocus = () => {
        this.setState({ isDropdownVisible: true }, () => {
            // 在状态更新完成后调用，确保下拉框已经渲染
            setTimeout(() => {
                this.setDropdownPosition();
            }, 0);
        });
    };

    handleHistoryItemClick = item => {
        console.log(item, "itm");

        this.setState({ keyword: item }, () => {
            this.handleSearch(item);
        });
    };

    handleDeleteHistory = (e, item) => {
        e.stopPropagation();
        const { historyKey = "brandAggregationHistory" } = this.props;

        const newHistory = this.state.searchHistory.filter(h => h !== item);
        this.setState({ searchHistory: newHistory });
        localStorage.setItem(historyKey, JSON.stringify(newHistory));
    };

    render() {
        const { keyword, isDropdownVisible, searchHistory } = this.state;
        const { className } = this.props;

        return (
            <div className="brand-search-box" ref={this.searchRef}>
                <div
                    className={`brand-search-input-wrapper ${className || ""}`}
                >
                    <Input
                        className="brand-search-input"
                        value={decodeURIComponent(keyword)}
                        onChange={e => {
                            const newValue = e.target.value;
                            this.setState({ keyword: e.target.value }, () => {
                                // 当输入框被清空时也调用父组件方法
                                if (!newValue) {
                                    this.props.onClean?.("");
                                }
                            });
                        }}
                        onFocus={this.handleInputFocus}
                        onPressEnter={this.handleKeyPress}
                        placeholder="Search assets"
                        clearable
                    />
                    <button
                        className="search-button"
                        onClick={() => this.handleSearch(keyword)}
                    >
                        <Icon
                            type="search"
                            style={{
                                fontSize: "21px",
                                fontWeight: "bold"
                            }}
                        />
                    </button>
                </div>
                {isDropdownVisible && searchHistory.length > 0 && (
                    <div
                        className="brand-search-dropdown"
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            width: "100%",
                            zIndex: 1000,
                            maxHeight: "300px",
                            overflowY: "auto"
                        }}
                    >
                        <div className="brand-search-history">
                            {searchHistory.map((item, index) => (
                                <div
                                    key={index}
                                    className="history-item"
                                    onClick={() =>
                                        this.handleHistoryItemClick(item)
                                    }
                                >
                                    <Icon
                                        type="time-o"
                                        style={{
                                            color: "#111925",
                                            fontSize: "20px"
                                        }}
                                        className="history-icon"
                                    />
                                    <span className="history-text">{item}</span>
                                    <Icon
                                        type="delete-o"
                                        className="delete-icon"
                                        onClick={e =>
                                            this.handleDeleteHistory(e, item)
                                        }
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
